var map = {
	"./balloons.png": "uYFl",
	"./beachball.png": "URlc",
	"./bird.png": "OjSN",
	"./butterflies.png": "nPHu",
	"./cat.png": "dF3P",
	"./clothing_01.png": "JAbn",
	"./clothing_02.png": "z61j",
	"./clothing_03.png": "bXPQ",
	"./clothing_08.png": "WPF9",
	"./clothing_10.png": "xrSV",
	"./clothing_11.png": "byci",
	"./clothing_12.png": "2ksa",
	"./clothing_13.png": "+a/8",
	"./confetti.png": "+82Z",
	"./crown.png": "J5DO",
	"./facialhair_03.png": "IuBB",
	"./flower.png": "Ijz4",
	"./flowers.png": "R1ET",
	"./glasses_02.png": "iG/n",
	"./hair_07.png": "dEDt",
	"./hat.png": "6l3L",
	"./helmet.png": "j3my",
	"./horse.png": "rAMq",
	"./necklace.png": "syBy",
	"./paintsplatter.png": "NEkS",
	"./spoon.png": "ZjoX",
	"./tie.png": "Lwxe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zqoP";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers ^\.\/.*\.png$
// module id = zqoP
// module chunks = 0